// 空模組：供 webpack 將僅 React Native 環境會用到的可選相依（如
// @react-native-async-storage/async-storage）在瀏覽器打包時導向此處。
// 瀏覽器不會執行到相關程式碼路徑，故匯出空物件即可。
export default {}
